import { useSwapContext } from "@src/context";
import { Controls } from "./Controls";

type Props = {
  onClose: () => void;
};
export const Header = ({ onClose }: Props) => {
  const { tab, bridgeUI } = useSwapContext();

  return (
    <div className="flex justify-between mt-2 px-4">
      <div className="text-xl font-sans-bold font-bold">
        {tab === "Swap" && bridgeUI ? "Bridge" : tab}
      </div>
      <Controls onClose={onClose} />
    </div>
  );
};
